interface ISiteElementButtonConfig {
    title: string;
    icon: string;
}

class SiteElementButton
    extends QueryElement<HTMLElement> {
        
    private readonly _title: QueryElement<HTMLElement>;
    private readonly _icon: QueryElement<HTMLElement>;
    
    constructor(config: ISiteElementButtonConfig) {
        super(document.createElement("DIV"));

        this._title = QueryElement.QueryElement("SPAN");
        this._icon = QueryElement.QueryElement("I");
        
        this.setTitle(config.title);
        this.setIcon(config.icon);

        this.append(this._title);
        this.append(this._icon);

        this.addClass("element-button");
    }

    setTitle(title: string) {
        this._title.setText(title);
    }
    setIcon(icon: string) {
        this._icon.setText(icon);
    }
}